<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-{{ color }}">
            <h4 class="card-title">
              <i class="material-icons clickable-icon" (click)="back()">arrow_left</i>
              {{ title }}
            </h4>
          </div>
          <div class="card-body">
            <div class="mb-3 d-flex justify-content-between align-items-center">
              <button mat-raised-button color="accent" (click)="runCheck()" [disabled]="loading">
                Run Check
              </button>

              <div class="ml-auto" *ngIf="rows && rows.length">
                <button class="btn btn-success btn-sm mr-2"
                        (click)="$event.preventDefault(); exportXls()"
                        [disabled]="loading || exporting">
                  <i class="fa fa-file-excel-o"></i> XLS
                </button>
                <button class="btn btn-danger btn-sm"
                        (click)="$event.preventDefault(); exportPdf()"
                        [disabled]="loading || exporting">
                  <i class="fa fa-file-pdf-o"></i> PDF
                </button>
              </div>
            </div>

            <!-- Loading -->
            <div class="row" *ngIf="loading">
              <div class="col-md-12 text-center">
                <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                  <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                </svg>
              </div>
            </div>

            <!-- Totals summary -->
            <div *ngIf="!loading && rows && rows.length" class="mb-2 text-right">
              <div>
                <strong>Total out of balance:</strong>
                {{ totalDifference | currency }}
              </div>
              <div class="text-muted small">
                Absolute out-of-balance total: {{ totalAbsDifference | currency }}
                &nbsp;•&nbsp; Journals: {{ rows.length }}
              </div>
            </div>

            <!-- Results / export content -->
            <div #print_table>
              <!-- Results table -->
              <div *ngIf="!loading && rows && rows.length">
                <div class="table-responsive">
                  <table mat-table [dataSource]="rows" class="mat-elevation-z1 full-width-table">
                  <!-- Type -->
                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef class="text-center"> Type </th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                      {{ row.typename }} ({{ row.type }})
                    </td>
                  </ng-container>

                  <!-- Transaction Number -->
                  <ng-container matColumnDef="typeno">
                    <th mat-header-cell *matHeaderCellDef class="text-center"> Transaction # </th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                      {{ row.typeno }}
                    </td>
                  </ng-container>

                  <!-- Order -->
                  <ng-container matColumnDef="order_">
                    <th mat-header-cell *matHeaderCellDef class="text-center"> Order # </th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                      {{ row.order_ || '—' }}
                    </td>
                  </ng-container>

                  <!-- Customer -->
                  <ng-container matColumnDef="customername">
                    <th mat-header-cell *matHeaderCellDef class="text-left"> Customer </th>
                    <td mat-cell *matCellDef="let row" class="text-left">
                      <div class="font-weight-bold" *ngIf="row.customername; else noCustomer">
                        {{ row.customername }}
                      </div>
                      <ng-template #noCustomer>
                        <span class="text-muted">N/A</span>
                      </ng-template>
                      <div class="text-muted small" *ngIf="row.debtorno">
                        {{ row.debtorno }}
                      </div>
                    </td>
                  </ng-container>

                  <!-- Period -->
                  <ng-container matColumnDef="periodno">
                    <th mat-header-cell *matHeaderCellDef class="text-center"> Period </th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                      <div>
                        {{ row.periodno }}
                      </div>
                      <div class="text-muted small" *ngIf="row.periodname">
                        {{ row.periodname | date }}
                      </div>
                    </td>
                  </ng-container>

                  <!-- Transaction Date -->
                  <ng-container matColumnDef="trandate">
                    <th mat-header-cell *matHeaderCellDef class="text-center"> Tran Date </th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                      {{ row.trandate | date }}
                    </td>
                  </ng-container>

                  <!-- Line Count -->
                  <ng-container matColumnDef="linecount">
                    <th mat-header-cell *matHeaderCellDef class="text-right"> Lines </th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                      {{ row.linecount || 0 }}
                    </td>
                  </ng-container>

                  <!-- Difference -->
                  <ng-container matColumnDef="difference">
                    <th mat-header-cell *matHeaderCellDef class="text-right"> Out of Balance </th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                      {{ row.difference | currency }}
                    </td>
                  </ng-container>

                  <!-- Actions -->
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="text-center"></th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                      <button mat-button color="primary"
                              (click)="viewGl(row)">
                        View GL
                      </button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                </div>
              </div>

              <!-- No results -->
              <div *ngIf="!loading && (!rows || !rows.length)" class="no-results-container">
                <h4>No out-of-balance GL transactions were found.</h4>
              </div>
            </div>

            <!-- Journal details modal (NgbModal, xl) -->
            <ng-template #journalDetails let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-title">
                  GL Journal
                  <span class="text-muted small" *ngIf="selectedJournal">
                    {{ selectedJournal.header.typename }} / {{ selectedJournal.header.typeno }}
                  </span>
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body" *ngIf="selectedJournal">
                <div class="mb-2 d-flex flex-wrap">
                  <div class="mr-4 mb-1">
                    <div class="small text-muted">Period</div>
                    <div>{{ selectedJournal.header.periodno }} – {{ selectedJournal.header.periodname | date }}</div>
                  </div>
                  <div class="mr-4 mb-1">
                    <div class="small text-muted">Tran Date</div>
                    <div>{{ selectedJournal.header.trandate | date }}</div>
                  </div>
                  <div class="mb-1">
                    <div class="small text-muted">Out of Balance</div>
                    <div class="font-weight-bold">{{ selectedJournal.difference | currency }}</div>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table table-sm table-striped table-bordered mb-0">
                    <thead>
                      <tr>
                        <th>Account</th>
                        <th>Description</th>
                        <th class="text-right">Debit</th>
                        <th class="text-right">Credit</th>
                        <th>Tag</th>
                        <th>Check #</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let line of selectedJournal.lines">
                        <td>{{ line.accountcode }} - {{ line.accountname }}</td>
                        <td>{{ line.narrative }}</td>
                        <td class="text-right">{{ line.debit | number: '1.2-2' }}</td>
                        <td class="text-right">{{ line.credit | number: '1.2-2' }}</td>
                        <td>{{ line.tagdescription || line.tag }}</td>
                        <td>{{ line.chequeno }}</td>
                      </tr>
                      <tr class="font-weight-bold">
                        <td colspan="2" class="text-right">Totals</td>
                        <td class="text-right">{{ modalTotalDebit | number: '1.2-2' }}</td>
                        <td class="text-right">{{ modalTotalCredit | number: '1.2-2' }}</td>
                        <td colspan="2">
                          Diff: {{ selectedJournal.difference | number: '1.2-2' }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="modal.close()">Close</button>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


